import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

interface MoneyIconProps {
  className?: string;
}

const MoneyIcon: FunctionComponent<MoneyIconProps> = ({ className }) => {
  return (
    <svg className={className || ''} viewBox="0 0 16 16">
      <Path
        d="M4.2,11c0.5,0.2,0.9,0.4,1.3,0.5c0.8,0.3,1.7,0.4,2.6,0.3c0.2,0,0.5-0.1,0.7-0.2c0.7-0.4,0.8-1.2,0.3-1.7
	c-0.3-0.3-0.6-0.5-1-0.6C7.5,9,6.9,8.8,6.3,8.6C5.7,8.3,5.2,8,4.7,7.6c-0.9-0.8-1.1-1.8-0.9-3c0.3-1.2,1.1-2,2.2-2.5
	C6.4,2,6.7,1.9,7,1.8C7,1.2,7,0.6,7,0c0.7,0,1.3,0,2,0c0,0.6,0,1.1,0,1.7c1,0,2,0.2,2.9,0.7c-0.2,0.7-0.4,1.5-0.6,2.2
	c-0.3-0.1-0.6-0.3-0.9-0.4C9.5,3.9,8.7,3.8,7.8,3.9C7.6,4,7.4,4.1,7.2,4.2C6.6,4.6,6.6,5.3,7.1,5.7c0.3,0.2,0.7,0.4,1.1,0.6
	c0.7,0.3,1.4,0.6,2.1,0.9s1.2,0.7,1.7,1.3c0.8,1.2,0.8,3.3-0.7,4.5c-0.6,0.5-1.4,0.8-2.2,1c-0.1,0-0.2,0.1-0.2,0.2
	c0,0.6,0,1.1,0,1.7c0,0.1,0,0.1,0,0.2c-0.6,0-1.3,0-1.9,0c0-0.6,0-1.2,0-1.8c-0.6-0.1-1.2-0.2-1.8-0.3c-0.5-0.1-0.9-0.3-1.4-0.5
	c-0.1,0-0.1-0.1-0.1-0.2C3.8,12.5,4,11.8,4.2,11C4.2,11.1,4.2,11.1,4.2,11z"
      />
    </svg>
  );
};

export default MoneyIcon;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.black};
`;
